import React, { useEffect, useState } from "react"
import ReactPopup from "reactjs-popup"
import styled from "styled-components"
import fonts from "../../../styles/fonts"
import breakpoints from "../../../styles/breakpoints"
import colors from "../../../styles/colors"
import { ButtonStyleGreen } from "../../Core/Buttons/Styles"
import CloseIcon from "../../../resources/img/ui/popup/account-close.svg"

const contentStyle = {
  width: "605px",
  margin: "auto",
  background: "transparent",
  boxSizing: "border-box",
  overflow: "auto",
}

const contentStyleMobile = {
  width: "100%",
  maxWidth: "500px",
  margin: "auto",
  marginTop: "60px",
  background: "transparent",
  height: "auto",
  overflow: "auto",
}

const overlayStyle = {
  overflowY: "auto",
  background: "rgba(248, 245, 243, 0.9)",
}

const CloseButton = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 32px;
  right: 32px;
  width: 23px;
  height: 23px;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`
const FirstPopup = styled.div`
  width: 100%;
  background: ${colors.white};
  padding: 46px 20px 45px;
  position: relative;
  border: none;

  @media (min-width: 720px) {
    padding: 56px 64px 24px;
    background: ${colors.beige};
    border: 1px solid ${colors.trueBlack};
  }
`

const LoginLinkPopup = styled.div`
  width: 100%;
  padding-top: 49px;
  border: none;
  margin-top: 16px;
  background: ${colors.white};
  padding: 46px 17px 45px;

  @media (min-width: 720px) {
    padding: 56px 64px 56px;
    background: ${colors.beige};
    border: 1px solid ${colors.trueBlack};
  }
`

const LinkButton = styled.button`
  ${ButtonStyleGreen};
  background: ${colors.lightGreen};
  border: 2px solid ${colors.lightGreen};
  width: 100%;
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.3px;
  ${fonts.helveticaNeueCondensedBold};
  padding: 17px 40px;
  margin: 24px 0 0;

  &:hover {
    background: ${colors.white};
    border: 2px solid ${colors.lightGreen};
    color: ${colors.lightGreen};
  }
`
const Title = styled.h2`
  ${fonts.selfModern};
  font-size: 34px;
  line-height: 32px;
  margin-bottom: 0px;
  color: ${colors.trueBlack};
  text-align: center;
  @media (min-width: ${breakpoints.md}) {
    font-size: 50px;
    line-height: 48px;
  }
`

const DoublePopup = ({
  isOpen,
  handlePopup,
  linkTitle,
  linkButton,
  linkAction,
  children,
  hideSecond
}) => {
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const updateWindowDimensions = () => {
      if (typeof window !== "undefined") {
        setWidth(window.innerWidth)
      }
    }

    updateWindowDimensions()
    window.addEventListener("resize", updateWindowDimensions)
    return () => {
      window.addEventListener("resize", updateWindowDimensions)
    }
  })

  const getContentStyle = () => {
    if (width >= 720) {
      let style = { ...contentStyle }
      return style
    } else if (width < 720) {
      return contentStyleMobile
    }
  }

  return (
    <ReactPopup
      open={isOpen}
      onClose={() => handlePopup(false)}
      closeOnDocumentClick
      contentStyle={getContentStyle()}
      overlayStyle={overlayStyle}
    >
      <FirstPopup>
        <CloseButton onClick={() => handlePopup(false)}>
          <img src={CloseIcon} alt="close" />
        </CloseButton>
        {children}
      </FirstPopup>
      {!hideSecond && <LoginLinkPopup>
        {linkTitle && <Title>{linkTitle}</Title>}
        {linkButton && <LinkButton onClick={linkAction}>{linkButton}</LinkButton>}
      </LoginLinkPopup>}
    </ReactPopup>
  )
}

export default DoublePopup
